import React from 'react';
import PropTypes from 'prop-types';
import styles from './FlyoutMenuItem.scss';
import notifyAnalytics from '../notify-analytics';
import formatTestId from '../../../utils/test-id/format-testid';

const FlyoutMenuItem = ({ label, url, hierarchy }) => {
  const navigate = () => {
    notifyAnalytics(`${hierarchy}|${label}`);
  };

  return (
    <li className={styles.flyoutMenuItem}>
      <a
        href={url}
        onClick={navigate}
        data-testid={`${formatTestId(label, 'nav-')}`}
      >
        {label}
      </a>
    </li>
  );
};

FlyoutMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  hierarchy: PropTypes.string.isRequired,
};

export default FlyoutMenuItem;
